export async function fetchAllPages<T>(
  fetchPage: (params: { page: number; pageSize: number }) => Promise<import('./paginationUtils').PaginatedResult<T>>,
  pageSize: number = 100
): Promise<T[]> {
  let page = 1;
  let results: T[] = [];

  while (true) {
    const res = await fetchPage({ page, pageSize });
    results = results.concat(res.data);

    if (!res.metadata.hasNextPage) {
      break;
    }

    page += 1;
  }

  return results;
}
